

















































/**
 * 标题续写:输入几个文字，则能够下拉提示
 * 适用场景：普通创意title，程序化创意title
 */
import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import { clone } from 'lodash-es';
import { useTitleSuggestion } from './use-title-suggestion';
import { useTrackTitleSuggestion } from './use-track-title-suggestion';
import { AcoFormData, AdgroupFormData, CampaignFormData, CREATIVE_TYPE, FullNormalFormData } from '@tt4b/ttam-enums';

const name = 'ttam-creative-title-suggestion';
export default defineComponent({
  name,
  components: {
    TextHighlight: () =>
      import(/* webpackChunkName: "vueTextHighlight" */ 'vue-text-highlight').then(res => res.default),
  },
  props: {
    titleIndex: {
      type: Number,
      default: 0,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, creativeData } = toRefs(props);
    const isAco = computed(() => adgroupData.value.creativeMaterialMode === CREATIVE_TYPE.PROCEDURAL);
    const {
      currentTitleIndex,
      isLoading,
      isShow,
      titleSuggestionInfo,
      hide: handleHide,
    } = useTitleSuggestion({
      adgroupData,
      campaignData,
      creativeData,
    });
    const { trackSelectSuggestion } = useTrackTitleSuggestion({ adgroupData, creativeData });

    // 当前请求下的建议列表和requestId
    const titleSuggestionList = computed(() => titleSuggestionInfo.value?.titles || []);
    const suggestionRequestId = computed(() => titleSuggestionInfo.value?.requestId || '');
    const isShowPopoverList = computed(() => isShow.value && currentTitleIndex.value === props.titleIndex);

    /**
     * 选择标题建议
     */
    const handleSelectSuggestionTitle = item => {
      if (isAco.value) {
        let originTitleList = clone(creativeData.value.titleList) || [];
        originTitleList[props.titleIndex] = {
          title: item.title,
          titleSuggestionInfo: {
            title: item.title,
            requestId: suggestionRequestId.value,
          },
        };
        emit('creativeData-change', { titleList: originTitleList });
      } else {
        emit('creativeData-change', {
          title: item.title,
          titleSuggestionInfo: {
            title: item.title,
            requestId: suggestionRequestId.value,
          },
        });
      }
      // 设置完成，清除表单校验
      emit('clear-validate');
      trackSelectSuggestion({ title: item.title });
      handleHide();
    };

    const handleOpenSmartText = () => {
      emit('open-smart-text');
      handleHide(true);
    };

    return {
      name,
      isLoading,
      isShowPopoverList,
      titleSuggestionList,
      handleSelectSuggestionTitle,
      handleOpenSmartText,
      handleHide,
    };
  },
});
